/**
 * Polling async createOrderV3 (HTTP 202) + fila "Procesando" en cuenta B2B.
 */
(function (global) {
  'use strict';

  var STORAGE_KEY = 'createOrderV3PendingPoll';
  var LEGACY_STORAGE_KEY = 'createOrderV2PendingPoll';
  var pollInFlight = false;

  var DEFAULTS = {
    intervalMs: 2000,
    maxMs: 120000,
    statusUrl:
      'https://xz9043fk1i.execute-api.us-west-2.amazonaws.com/Prod/api/createOrderV3Status',
  };

  var PENDING_STATUSES = {
    QUEUED: true,
    IN_PROGRESS: true,
    PROCESSING: true,
    CREATING: true,
  };

  function isAsyncCreateOrderEnabled() {
    return global.B2B_ASYNC_CREATE_ORDER_ENABLED === true;
  }

  function clearStalePollIfDisabled() {
    if (!isAsyncCreateOrderEnabled()) {
      clearPendingPoll();
    }
  }

  function trimStr(v) {
    return v == null ? '' : String(v).trim();
  }

  function parseJsonSafe(text) {
    try {
      return text && trimStr(text) ? JSON.parse(text) : {};
    } catch (e) {
      return {};
    }
  }

  function normalizePostStatus(parsed) {
    if (!parsed || typeof parsed !== 'object') return '';
    var status = parsed.status || parsed.creation_phase || '';
    return String(status || '').toUpperCase();
  }

  function isAsyncPostResponse(httpStatus, parsed) {
    return httpStatus === 202;
  }

  function isIdempotentDonePostResponse(httpStatus, parsed) {
    if (httpStatus !== 200 || !parsed || typeof parsed !== 'object') return false;
    return normalizePostStatus(parsed) === 'DONE';
  }

  /** POST 200 DONE con idempotent_replay (o sin flag, compat) = pedido ya procesado. */
  function isIdempotentReplayResponse(httpStatus, parsed) {
    if (!parsed || typeof parsed !== 'object') return false;
    if (parsed.idempotent_replay === true) return true;
    return isIdempotentDonePostResponse(httpStatus, parsed);
  }

  function normalizeIdempotentDonePostBody(parsed) {
    var result = extractDoneResult(parsed);
    var out = Object.assign({}, parsed);
    if (result && typeof result === 'object' && result.ok != null) {
      out.ok = result.ok;
    } else if (typeof result === 'string' && trimStr(result)) {
      out.ok = result;
    }
    if (parsed.idempotent_replay === true) {
      out.idempotent_replay = true;
    }
    return out;
  }

  function formatCreationDate(date) {
    var d = date instanceof Date ? date : new Date();
    if (isNaN(d.getTime())) d = new Date();
    var day = String(d.getDate()).padStart(2, '0');
    var month = String(d.getMonth() + 1).padStart(2, '0');
    var year = d.getFullYear();
    var hours = String(d.getHours()).padStart(2, '0');
    var mins = String(d.getMinutes()).padStart(2, '0');
    var secs = String(d.getSeconds()).padStart(2, '0');
    return day + '/' + month + '/' + year + ' ' + hours + ':' + mins + ':' + secs;
  }

  function getPendingPoll() {
    try {
      var raw = global.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) {
        raw = global.sessionStorage.getItem(LEGACY_STORAGE_KEY);
      }
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function savePendingPoll(poll) {
    if (!poll || !poll.request_id) return;
    try {
      global.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(poll));
      global.sessionStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function clearPendingPoll() {
    try {
      global.sessionStorage.removeItem(STORAGE_KEY);
      global.sessionStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function buildPendingFromAccepted(apiBody, orderData, ownerId, isPreorder, orderType) {
    var body = apiBody && typeof apiBody === 'object' ? apiBody : {};
    var order = orderData && typeof orderData === 'object' ? orderData : {};
    var now = new Date();
    var postStatus = normalizePostStatus(body);
    var resolvedOrderType = orderType || order.order_type || null;
    return {
      request_id: body.request_id || body.requestId || body.hash_id || null,
      draft_order_id: body.draft_order_id || body.draftOrderId || body.id || null,
      creation_phase: body.creation_phase || postStatus || 'QUEUED',
      creation_date: formatCreationDate(now),
      status: 'PROCESSING',
      is_preorder: !!isPreorder,
      order_type: resolvedOrderType ? String(resolvedOrderType).toUpperCase() : null,
      owner: ownerId != null ? ownerId : order.customer_id || null,
      draft_order: {
        name: order.name || '',
        customer_name: order.customer_name || '',
        customer_email: order.customer_email || order.selected_customer_email || '',
        line_items: Array.isArray(order.line_items) ? order.line_items : [],
      },
      started_at: now.getTime(),
    };
  }

  function isPreorderPendingPoll(pending) {
    return !!(pending && pending.is_preorder);
  }

  function isWebOrderPendingPoll(pending) {
    return !!(
      pending &&
      String(pending.order_type || '').toUpperCase() === 'WEB_ORDER'
    );
  }

  function buildListOrderFromPending(pending, customerId) {
    pending = pending || {};
    return {
      draft_order_id: pending.draft_order_id || 'polling-' + (pending.request_id || 'pending'),
      status: 'PROCESSING',
      creation_date: pending.creation_date || formatCreationDate(new Date()),
      owner: pending.owner != null ? pending.owner : customerId,
      draft_order: pending.draft_order || {},
      _isPollingPlaceholder: true,
      _pollRequestId: pending.request_id || null,
    };
  }

  function resolveStatusUrl(options) {
    options = options || {};
    if (options.statusUrl) return options.statusUrl;
    if (global.B2B_CREATE_ORDER_V3_STATUS_URL) return global.B2B_CREATE_ORDER_V3_STATUS_URL;
    return DEFAULTS.statusUrl;
  }

  function mergeConfig(options) {
    options = options || {};
    return {
      intervalMs: options.intervalMs || DEFAULTS.intervalMs,
      maxMs: options.maxMs || DEFAULTS.maxMs,
      statusUrl: resolveStatusUrl(options),
    };
  }

  function normalizeStatusPayload(data) {
    if (!data || typeof data !== 'object') return { status: '' };
    var status = data.status || data.creation_phase || '';
    if (!status && data.result && typeof data.result === 'object') {
      status = data.result.status || 'DONE';
    }
    return {
      status: String(status || '').toUpperCase(),
      data: data,
    };
  }

  function isPendingPollStatus(status) {
    if (!status) return true;
    return !!(
      PENDING_STATUSES[status] ||
      PENDING_STATUSES[String(status).replace(/-/g, '_')] ||
      String(status).indexOf('QUEUED') !== -1 ||
      String(status).indexOf('IN_PROGRESS') !== -1 ||
      String(status).indexOf('PROGRESS') !== -1
    );
  }

  function extractDoneResult(data) {
    if (!data || typeof data !== 'object') return data;
    if (data.result != null) return data.result;
    if (data.response_body) {
      try {
        return JSON.parse(data.response_body);
      } catch (e) {
        return data.response_body;
      }
    }
    return data;
  }

  /** Convierte la respuesta DONE del status endpoint al shape de fila de la tabla. */
  function normalizeListOrderFromPollDone(parsed) {
    if (!parsed || typeof parsed !== 'object') return null;
    var record = parsed.draft_order;
    if (!record || typeof record !== 'object') {
      var fallbackId = parsed.draft_order_id;
      if (!fallbackId && parsed.result && typeof parsed.result === 'object') {
        fallbackId = parsed.result.ok || parsed.result.draft_order_id || parsed.result.id;
      }
      if (!fallbackId) return null;
      return {
        draft_order_id: fallbackId,
        status: 'PENDING',
        draft_order: {},
      };
    }

    var draftOrderObj =
      record.draft_order && typeof record.draft_order === 'object'
        ? Object.assign({}, record.draft_order)
        : {};

    if (record.name) draftOrderObj.name = draftOrderObj.name || record.name;
    if (Array.isArray(record.items) && record.items.length) {
      draftOrderObj.line_items = record.items;
    }

    return {
      draft_order_id: record.draft_order_id || parsed.draft_order_id,
      status: record.status || 'PENDING',
      creation_date: record.creation_date,
      last_updated_date: record.last_updated_date,
      owner: record.owner,
      user_id: record.user_id,
      name: record.name,
      order_type: record.order_type,
      actors: record.actors,
      commercial_id: record.commercial_id,
      selected_customer_id: record.selected_customer_id,
      order_id: record.order_id,
      draft_order: draftOrderObj,
    };
  }

  function extractErrorMessage(data) {
    if (!data || typeof data !== 'object') return 'Error al procesar el pedido.';
    if (typeof data.message === 'string' && trimStr(data.message)) return data.message;
    if (typeof data.error === 'string' && trimStr(data.error)) return data.error;
    if (data.error && typeof data.error === 'object') {
      if (typeof data.error.message === 'string' && trimStr(data.error.message)) {
        return data.error.message;
      }
      try {
        var errJson = JSON.stringify(data.error);
        if (trimStr(errJson) && errJson !== '{}') return errJson;
      } catch (e) {
        /* ignore */
      }
    }
    if (data.result && typeof data.result.message === 'string') return data.result.message;
    return 'Error al procesar el pedido.';
  }

  // El registro temporal del pedido (b2b_orders_tmp) se lee con consistencia
  // eventual: justo tras encolar (HTTP 202) un primer poll puede no verlo todavía
  // y devolver 404 NOT_FOUND. Toleramos unos cuantos 404 consecutivos antes de
  // tratarlo como error real para no mostrar un falso "Error al procesar el pedido".
  var MAX_NOT_FOUND_RETRIES = 6;

  function pollUntilDone(requestId, options) {
    var cfg = mergeConfig(options);
    var started = Date.now();
    var notFoundRetries = 0;

    function sleep(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    function tick() {
      if (Date.now() - started > cfg.maxMs) {
        return Promise.reject({ timeout: true, message: 'Polling timeout' });
      }
      var url =
        cfg.statusUrl +
        (cfg.statusUrl.indexOf('?') === -1 ? '?' : '&') +
        'request_id=' +
        encodeURIComponent(requestId);
      return fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })
        .then(function (response) {
          return response.text().then(function (text) {
            var parsed = parseJsonSafe(text);
            var norm = normalizeStatusPayload(parsed);
            if (norm.status === 'ERROR' || norm.status === 'FAILED') {
              return Promise.reject({
                error: true,
                httpStatus: parsed.http_status || response.status,
                data: parsed,
                message: extractErrorMessage(parsed),
              });
            }
            // 404/NOT_FOUND: el registro aún no es visible (consistencia eventual)
            // o es un poll obsoleto; reintentar unas veces antes de fallar.
            if (response.status === 404 || norm.status === 'NOT_FOUND') {
              notFoundRetries += 1;
              if (notFoundRetries <= MAX_NOT_FOUND_RETRIES) {
                return { __retryNotFound: true };
              }
              return Promise.reject({
                error: true,
                httpStatus: 404,
                data: parsed,
                message: extractErrorMessage(parsed),
              });
            }
            if (!response.ok) {
              return Promise.reject({
                error: true,
                httpStatus: response.status,
                data: parsed,
                message: extractErrorMessage(parsed),
              });
            }
            notFoundRetries = 0;
            return parsed;
          });
        })
        .then(function (parsed) {
          if (parsed && parsed.__retryNotFound) {
            return sleep(cfg.intervalMs).then(tick);
          }
          var norm = normalizeStatusPayload(parsed);
          if (
            norm.status === 'DONE' ||
            norm.status === 'COMPLETE' ||
            norm.status === 'COMPLETED' ||
            norm.status === 'SUCCESS'
          ) {
            return {
              done: true,
              result: extractDoneResult(parsed),
              parsed: parsed,
              order: normalizeListOrderFromPollDone(parsed),
            };
          }
          if (norm.status === 'ERROR' || norm.status === 'FAILED') {
            return Promise.reject({
              error: true,
              data: parsed,
              message: extractErrorMessage(parsed),
            });
          }
          if (isPendingPollStatus(norm.status)) {
            return sleep(cfg.intervalMs).then(tick);
          }
          return sleep(cfg.intervalMs).then(tick);
        });
    }

    return tick();
  }

  function startAccountPolling(options) {
    if (!isAsyncCreateOrderEnabled()) return Promise.resolve({ skipped: true });
    if (pollInFlight) return Promise.resolve({ skipped: true });
    var pending = getPendingPoll();
    if (!pending || !pending.request_id) return Promise.resolve({ skipped: true });

    pollInFlight = true;
    return pollUntilDone(pending.request_id, options)
      .then(function (outcome) {
        clearPendingPoll();
        pollInFlight = false;
        if (options && typeof options.onDone === 'function') {
          options.onDone(outcome.order || normalizeListOrderFromPollDone(outcome.parsed), outcome);
        }
        return outcome;
      })
      .catch(function (err) {
        pollInFlight = false;
        if (err && err.timeout) {
          if (options && typeof options.onTimeout === 'function') {
            options.onTimeout(pending);
          }
          return { timeout: true };
        }
        clearPendingPoll();
        if (options && typeof options.onError === 'function') {
          options.onError(err);
        }
        throw err;
      });
  }

  function pinProcessingRowFirst(container) {
    if (!container) return;
    var processing = Array.from(
      container.querySelectorAll(
        '.order-item[data-processing-poll="true"], .dashboard-preorder-item[data-processing-poll="true"]'
      )
    );
    var rest = Array.from(
      container.querySelectorAll(
        '.order-item:not([data-processing-poll="true"]), .dashboard-preorder-item:not([data-processing-poll="true"])'
      )
    );
    processing.concat(rest).forEach(function (item) {
      container.appendChild(item);
      if (!item.classList.contains('order-item')) return;
      var orderId = item.id.replace(/^order-/, '');
      var details = container.querySelector('#order-details-' + orderId);
      if (details) container.appendChild(details);
    });
  }

  global.GobikCreateOrderPolling = {
    STORAGE_KEY: STORAGE_KEY,
    LEGACY_STORAGE_KEY: LEGACY_STORAGE_KEY,
    DEFAULTS: DEFAULTS,
    getPendingPoll: getPendingPoll,
    savePendingPoll: savePendingPoll,
    clearPendingPoll: clearPendingPoll,
    buildPendingFromAccepted: buildPendingFromAccepted,
    isPreorderPendingPoll: isPreorderPendingPoll,
    isWebOrderPendingPoll: isWebOrderPendingPoll,
    buildListOrderFromPending: buildListOrderFromPending,
    normalizeListOrderFromPollDone: normalizeListOrderFromPollDone,
    pollUntilDone: pollUntilDone,
    startAccountPolling: startAccountPolling,
    pinProcessingRowFirst: pinProcessingRowFirst,
    isAsyncCreateOrderEnabled: isAsyncCreateOrderEnabled,
    clearStalePollIfDisabled: clearStalePollIfDisabled,
    parseJsonSafe: parseJsonSafe,
    isAsyncPostResponse: isAsyncPostResponse,
    isIdempotentDonePostResponse: isIdempotentDonePostResponse,
    isIdempotentReplayResponse: isIdempotentReplayResponse,
    normalizeIdempotentDonePostBody: normalizeIdempotentDonePostBody,
    isAcceptedResponse: function (status) {
      return status === 202;
    },
  };
})(typeof window !== 'undefined' ? window : this);
